import SeedRandom from 'seedrandom';

export function isInt(value){
    return !!((parseFloat(value) == parseInt(value)) && !isNaN(value));
}

export function isNumber(obj) { return !isNaN(parseFloat(obj)) }

export function indexToText(index) {
    var map = [
        'first',
        'second',
        'third',
        'fourth',
        'fifths',
        'sixth',
        'seventh',
        'eights',
        'ninth'
    ]

    if(map.length < index + 1) {
        return index + 1+'.';
    }

    return map[index];
}

export function between(minNumber, maxNumber, seedRandom = new SeedRandom()) {
    if(minNumber > maxNumber) { minNumber = maxNumber; }

    var randomFNumber = Math.floor(seedRandom() * (maxNumber - minNumber + 1)) + minNumber;
    return randomFNumber;
}

export function withLength(minLength = 2, maxLength = 3, seedRandom = new SeedRandom()) {
    var dCount = between(minLength, maxLength, seedRandom);

    // when first digit after zero is zero to, it will generate numbers of random lengths which is not what we want
    var rnd = seedRandom();
    while (rnd < 0.1) {
        rnd = seedRandom();
    }

    return Math.floor(rnd * Math.pow(10, dCount) - 1) + 1;
}

export function flip(seedRandom = new SeedRandom()) {
    return between(0, 1, seedRandom);
}

export function roll(percentage, seedRandom = new SeedRandom()) {
    var nr = between(1, 100, seedRandom);
    return nr <= percentage;
}


// GETTER
// from higher
export function _dh(number, from, to) {
    to = typeof to === 'undefined' ? from : to;
    from = from - 1;

    return {
        value: parseFloat(number.toString().substring(from, to)),
        from: from,
        to: to,
    };
}

export function dh(number, from, to) {
    return _dh(number, from, to).value;
}

export function _dhFirst(number, to = 1) {
    return _dh(number, 1, to);
}
export function dhFirst(number, to = 1) {
    return _dhFirst(number, to).value;
}

export function _dhExcept(number, count) {
    return _dh(number, 0, dCount(number) - count);
}
export function dhExcept(number, count) {
    return _dhExcept(number, count).value;
}

export function _dhFull(number, from, to) {
    to = typeof to === 'undefined' ? from : to;

    var digits = _dh(number, from, to);

    digits.value = digits.value * Math.pow(10, dCount(number) - to);
    return digits;
}
export function dhFull(number, from, to) {
    return _dhFull(number, from, to).value;
}

// from lower
export function _dl(number, from, to) {
    to = typeof to === 'undefined' ? from : to;

    var dCount = dCount(number);

    return _dh(number, dCount - from + 1, dCount - to + 1);
}
export function dl(number, from, to) {
    return _dl(number, from, to).value;
}

export function _dlFirst(number, to = 1) {
    return _dl(number, to, 1);
}
export function dlFirst(number, to = 1) {
    return _dlFirst(number, to).value;
}

export function _dlExcept(number, count) {
    return _dl(number, dCount(number) - count, 1);
}
export function dlExcept(number, count) {
    return _dlExcept(number, count).value;
}

export function _dlFull(number, from, to) {
    to = typeof to === 'undefined' ? from : to;

    var digits = _dl(number, from, to);
    digits.value = digits.value * Math.pow(10, to-1);
    return digits;
}
export function dlFull(number, from, to) {
    return _dlFull(number, from, to).value;
}

// ALGORITHMS
export function dCount(number) {
    var base = 10,
        exponent = 0,
        subtractor = 1;

    while ((number - subtractor) >= 0) {
        subtractor *= base;
        exponent++;
    }

    return exponent;
}

export function zCount(number) {
    var nStr = number+'',
        count = 0;

    for(let i = nStr.length-1; i > 0; i++) {
        let digit = nStr[i];

        if(digit == '0') { break; }

        count++;
    }

    return count;
}

export function dNonZero(number) {
    return dCount(number) - zCount(number);
}

export function iterateNumbers(number, number2, func) {
    var dCount1 = dCount(number),
        dCount2 = dCount(number2),
        count = dCount1 <= dCount2 ? dCount1 : dCount2;

    for(var i = 0; i < count; i++) {
        var d1 = dl(number, i + 1),
            d2 = dl(number2, i + 1);

        func(d1, d2, i);
    }
}

export function numberStepCount(number, number2) {
    var nonTrivialCount = 0;

    iterateNumbers(number, number2, (d1, d2) => {
        if(d1 != 0 && d2 != 0) {
            nonTrivialCount++;
        }
    });

    return nonTrivialCount;
}

export function additionCarryCount(number, number2) {
    var carryCount = 0;

    iterateNumbers(number, number2, (d1, d2) => {
        carryCount += (d1 + d2 > 10);
    });

    return carryCount;
}

export function isTrivialAddition(number, number2) {
    return numberStepCount(number, number2) < 2;
}

export function multiply(number, number2 = 1) {
    return parseFloat(number) * parseFloat(number2);
}

export function divide(number, number2 = 1) {
    return parseFloat(number) / parseFloat(number2);
}

export function add(number, number2 = 0) {
    return parseFloat(number) + parseFloat(number2);
}

export function subtract(number, number2 = 0) {
    return parseFloat(number) - parseFloat(number2);
}

export function square(number) {
    return parseFloat(number) * parseFloat(number);
}

export function append() {
    var returnStr = '';

    for (let i = 0; i < arguments.length; i++) {
        let argument = arguments[i];
        returnStr += (argument).toString();
    }

    return parseFloat(returnStr);
}

export function prepend(number, value = 0) {
    return parseFloat((value).toString() + (number).toString());
}

export function complement(number) {
    var nextPotency = nextHigher(number);
    return nextPotency - number;
}

export function nextHigher(number) {
    if (number <= 10)
        return 10;

    return (dhFirst(number)+1) * Math.pow(10, dCount(number) - 1);
}

export function crossSum(number) {
    var str = number.toString();
    var sum = 0;

    for (var i = 0; i < str.length; i++) {
        sum += parseInt(str.charAt(i), 10);
    }

    return sum;
}

export function smallestFactor(number, minimumDivisor , highestDivisor) {
    var divisor = minimumDivisor;

    do {
        var divisable = number % divisor == 0 && number / divisor <= highestDivisor;
        if(divisable) {
            return divisor;
        }

        divisor++;
    } while(divisor <= highestDivisor && divisor < number);

    return 0;
}